import React, { useState, useEffect } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useGroupState, useGroupActions } from './GroupContext';
import { getGroups } from './restApi';
import GroupCard from './GroupCard';
import PlaceholderCard from '../../Shared/UI/PlaceholderCard/components/PlaceholderCard';
import styles from './GroupGrid.module.scss';

const GroupGrid = ({ authenticatedUser }) => {
  const state = useGroupState();
  const { openGroupModal, loadMoreGroupsOnResponse, onError } = useGroupActions();
  const [isLargeScreen, setIsLargeScreen] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsLargeScreen(window.innerWidth >= 769);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const loadMoreGroups = () => {
    if (state?.canViewMoreGroups === false) {
      return;
    }

    getGroups({
      lastPageViewed: state?.lastPageViewed || 0,
      onResponse: loadMoreGroupsOnResponse,
      onError,
    });
  };

  const groups = (state?.groups || []).map((group, index) => {
    return (
      <GroupCard key={index} group={group} />
    );
  });

  const minCardsForLargeScreen = 6;
  const minCardsForSmallScreen = 1;
  const currentGroupCount = groups.length;
  const minCardsNeeded = isLargeScreen ? minCardsForLargeScreen : minCardsForSmallScreen;
  const fillerCardsNeeded = Math.max(0, minCardsNeeded - currentGroupCount);

  const canCreateGroups = authenticatedUser?.canCreateGroups === true;

  const fillerCards = [];
  if (fillerCardsNeeded > 0) {
    for (let i = 0; i < fillerCardsNeeded; i++) {
      fillerCards.push(
        <PlaceholderCard
          key={`filler-${i}`}
          onClick={canCreateGroups ? () => openGroupModal() : null}
        >
          {canCreateGroups && <span className={styles.plusSign}>+</span>}
        </PlaceholderCard>
      );
    }
  }

  const groupsCount = (state?.groups || []).length;
  const hasMore = state?.canViewMoreGroups === true;
  const isLoading = state?.loading === true && groupsCount === 0;

  return (
    <div id={styles.infinitScrollContainer}>
      <InfiniteScroll
        dataLength={groupsCount}
        next={loadMoreGroups}
        hasMore={hasMore}
        loader={isLoading ? <h4 style={{ textAlign: 'center' }}>Loading...</h4> : null}
        endMessage={
          <p style={{ textAlign: 'center' }}>
            <b>You've seen all the groups available for you to see.</b>
          </p>
        }
        scrollableTarget={styles.infinitScrollContainer}
      >
        <div className={styles.groupsGrid}>
          {groups}
          {fillerCards}
        </div>
      </InfiniteScroll>
    </div>
  );
};

export default GroupGrid;
